import { tv } from 'tailwind-variants'

export const headerVariants = tv({
  slots: {
    container: 'font-bold text-mili mb-deca'
  }
})
